// A bubble of chewing gum, sizes in units of the toy's radius. Blowing grows
// it, more slowly as it gets bigger (a bigger bubble needs more air for the
// same growth), and its film thins as it stretches. Let go and it shrinks
// back into the mouth. Past its own limit it pops: the gum snaps back and
// sticks over the face for a moment, then is chewed back in.
export class GumBubble{
  constructor({size=1,random=Math.random}={}){
    this.size=size;this.random=random;this.radius=0;this.phase='idle';this.splat=0;this.clock=0;this.stuckUntil=0;
    this.newLimit();
  }
  newLimit(){this.popAt=this.size*(1.05+.3*this.random());}
  // 0 for a fresh blob of gum, 1 for a film about to burst.
  get film(){return Math.min(1,this.radius/this.popAt);}
  step(dt,blowing){
    const events=[],R=this.size;this.clock+=dt;
    if(this.phase==='popped'){
      // Stuck to the face, then chewed back in from the edges.
      if(this.clock>this.stuckUntil)this.splat=Math.max(0,this.splat-dt/2.4);
      if(this.splat===0){this.phase='idle';this.newLimit();events.push('chewed');}
      return events;
    }
    if(blowing){
      if(this.phase!=='blowing')events.push('blow');
      this.phase='blowing';this.radius+=dt*R*.75/(1+1.6*this.radius/R);
      if(this.radius>=this.popAt){this.radius=0;this.phase='popped';this.splat=1;this.stuckUntil=this.clock+1.1;events.push('pop');}
    }else if(this.radius>0){
      if(this.phase!=='deflating')events.push('deflate');
      this.phase='deflating';this.radius=Math.max(0,this.radius-dt*R*(.5+1.2*this.radius/R));
      if(this.radius===0)this.phase='idle';
    }
    return events;
  }
  reset(){this.radius=0;this.phase='idle';this.splat=0;this.newLimit();}
}
